"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailBox = exports.tag = void 0;

var _swatches = require("../swatches");

var _base = require("./base");

var tag = {
  bg: _swatches.monochrome.light,
  closeIcon: _swatches.monochrome.mediumDark,
  closeIconHover: _swatches.monochrome.dark
};
exports.tag = tag;
var emailBox = {
  text: _swatches.monochrome.black,
  errorText: _swatches.monochrome.white,
  errorBg: _base.primary.negative,
  closeIconError: _swatches.monochrome.white
};
exports.emailBox = emailBox;
//# sourceMappingURL=tag.js.map